import React, { FC } from 'react';
import styled from 'styled-components';

interface PageContentProps {
  style?: React.CSSProperties;
  'data-test': string;
  className?: string;
}

export const PageContent: FC<React.PropsWithChildren<PageContentProps>> = ({
  className,
  style,
  children,
  'data-test': dataTest
}) => (
  <StyledPageContent className={className} data-test={dataTest} style={style}>
    {children}
  </StyledPageContent>
);

const StyledPageContent = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
`;
